import { cn, dayjs } from '@/utils';
import React, { memo, useCallback } from 'react';

import { TimePicker, TimePickerProps } from 'antd';

import { Dayjs } from 'dayjs';

export type TimePickerData = {
	name: string;
	dateString: string | string[];
	date: Dayjs;
};

export type TimePickerFormProps = Omit<
	TimePickerProps,
	'value' | 'onChange'
> & {
	name?: string;
	className?: string;
	value: string;
	onChange?: (data: TimePickerData) => void;
	boxStyle?: React.CSSProperties;
	containerClassName?: string;
};

const TimePickerForm = ({
	className,
	value,
	boxStyle,
	containerClassName,
	name = '',
	onChange,
	...rest
}: TimePickerFormProps) => {
	const _onChange = useCallback(
		(date: Dayjs, dateString: string | string[]) => {
			onChange?.({
				date,
				dateString,
				name,
			});
		},
		[onChange, name]
	);
	return (
		<div className={containerClassName} style={boxStyle}>
			<TimePicker
				onChange={_onChange}
				suffixIcon
				inputReadOnly
				className={cn(
					'bg-transparent hover:bg-transparent focus:bg-transparent focus-within:bg-transparent !border-none focus:!outline-none !shadow-none p-0 date-input',
					className
				)}
				value={value ? dayjs(value, 'HH:mm') : null}
				{...rest}
			/>
		</div>
	);
};

export default memo(TimePickerForm);
